import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Button, ButtonProps } from '@mui/material';
import { useIntl } from 'react-intl';

export type ResetBtnProps = Omit<ButtonProps, 'startIcon' | 'children'> & {
  children?: React.ReactNode;
};

export const ResetBtn = (p: ResetBtnProps) => {
  const { $t } = useIntl();
  return (
    <Button variant="outlined" startIcon={<RestartAltIcon fontSize="inherit" />} {...p}>
      {p.children ?? $t({ id: 'common.reset', defaultMessage: 'Reset' })}
    </Button>
  );
};
